import { type PropsWithChildren } from 'react';
import '@common/styles/components/pageFooter.pcss';

function PageFooterWrapper({ children }: Readonly<PropsWithChildren<{}>>) {
  return (
    <footer className="page-footer">
      <div className="container flex-row-desktop flex-column-reverse-mobile align-items-center justify-content-space-between">
        {children}
      </div>
    </footer>
  );
}

export default PageFooterWrapper;
